import axios from "./_axios";
import { API } from "./apiEndPoints";
import { updateAccountCounts } from "@/utils/accountCountUtils";
import qs from "qs";

export const getListOfPositions = async (account_id, page_no, size) => {
  let result = await axios()({
    method: "get",
    url: `${API.ACCOUNTList}${account_id}/position/`,
    params: { page: page_no, size: size },
  });
  return result;
};
export const getListOfPositionsForAssignment = async ({
  accountId,
  limit,
  offset,
  name,
}) => {
  let result = await axios()({
    method: "get",
    url: `${API.ACCOUNT_LIST_V2}${accountId}/position/`,
    params: { not_assigned: 1, limit, offset, name, ordering: "name" },
  });
  return result;
};
export const getListOfPositionsForPrepareAssignment = async ({
  accountId,
  limit,
  offset,
  name,
}) => {
  let result = await axios()({
    method: "get",
    url: `${API.ACCOUNT_LIST_V2}${accountId}/position/`,
    params: { limit, offset, name, ordering: "name", status: "active" },
  });
  return result;
};

//https://api.dev.exiqtive.com/api/proficiency/v2/account/2/position/
export const getListOfPositionsV2 = async ({ account_id, queryParamsObj }) => {
  let result = await axios()({
    method: "get",
    url: `${API.ACCOUNT_LIST_V2}${account_id}/position/`,
    params: { ...queryParamsObj },
    paramsSerializer: (params) => {
      return qs.stringify(params, { arrayFormat: "repeat" });
    },
  });
  return result;
};

export const createPosition = (account_id, data) => {
  let result = axios()({
    method: "post",
    url: `${API.ACCOUNTList}${account_id}/position/`,
    data: data,
  });
  return result;
};
export const updatePosition = (account_id, position_id, data) => {
  let result = axios()({
    method: "put",
    url: `${API.ACCOUNTList}${account_id}/position/${position_id}/`,
    data: data,
  });
  return result;
};
export const addPositionAssignment = (account_id, data) => {
  let result = axios()({
    method: "post",
    url: `${API.ACCOUNTList}${account_id}/position-assignment/add/`,
    data: data,
  });
  return result;
};
export const updatePositionAssignment = (account_id, data, id) => {
  let result = axios()({
    method: "patch",
    url: `${API.ACCOUNTList}${account_id}/position-assigment/${id}/`,
    data: data,
  });
  return result;
};
export const deletePosition = (account_id, position_id) => {
  let result = axios()({
    method: "delete",
    url: `${API.ACCOUNTList}${account_id}/position/${position_id}/`,
  });
  return result;
};
export const attachRoleToPosition = (account_id, roleId, data) => {
  let result = axios()({
    method: "post",
    url: `${API.ACCOUNTList}${account_id}/position/${roleId}/attach/`,
    data: data,
  });
  return result;
};
export const getPositionChatter = (account_id, position_id, page_no) => {
  let result = axios()({
    method: "get",
    url: `${API.ACCOUNTList}${account_id}/position/${position_id}/chatter/`,
    params: { page: page_no },
  });
  return result;
};
export const updatePositionExcludeValue = (account_id, position_id, data) => {
  let result = axios()({
    method: "patch",
    url: `${API.ACCOUNTList}${account_id}/position/${position_id}/`,
    data: data,
  });
  return result;
};
export const activatePosition = async (account_id, position_id) => {
  let result = await axios()({
    method: "post",
    url: `${API.ACCOUNTList}${account_id}/position/${position_id}/activate/`,
  });
  await updateAccountCounts(account_id);
  return result;
};
export const deActivatePosition = async (account_id, position_id) => {
  let result = await axios()({
    method: "post",
    url: `${API.ACCOUNTList}${account_id}/position/${position_id}/de-activate/`,
  });
  await updateAccountCounts(account_id);
  return result;
};
export const reActivatePosition = async (account_id, position_id) => {
  let result = await axios()({
    method: "post",
    url: `${API.ACCOUNTList}${account_id}/position/${position_id}/re-activate/`,
  });
  await updateAccountCounts(account_id);
  return result;
};
export const retirePosition = async (account_id, position_id) => {
  let result = await axios()({
    method: "post",
    url: `${API.ACCOUNTList}${account_id}/position/${position_id}/retire/`,
  });
  await updateAccountCounts(account_id);
  return result;
};
export const archivePosition = async (account_id, objType, orgId) => {
  let result = await axios()({
    method: "post",
    url: `${API.ACCOUNTList}${account_id}/${objType}/${orgId}/archive/`,
  });
  await updateAccountCounts(account_id);
  return result;
};
export const unArchivePosition = async (account_id, objType, orgId) => {
  let result = await axios()({
    method: "post",
    url: `${API.ACCOUNTList}${account_id}/${objType}/${orgId}/unarchive/`,
  });
  await updateAccountCounts(account_id);
  return result;
};

export const getPositionAssignments = (
  account_id,
  employee_id,
  page = 1,
  size = 10,
  status = null
) => {
  let result = axios()({
    method: "get",
    url: `${
      API.ACCOUNT_LIST_V2
    }${account_id}/position-assignment/?employee=${employee_id}&page=${page}&size=${size}${
      status ? `&status=${status}` : ""
    }`,
  });
  return result;
};
